module.exports = __webpack_public_path__ + "static/media/gdpr-icon.3d92feb7.png";